import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';

import { AuthProvider } from './services/AuthContext';
import { AppLayout } from './components/Layout/AppLayout';


function App() {
  return (
    <ThemeProvider>
        <Router>
          <AuthProvider>
            <AppLayout />
          </AuthProvider>

          
        </Router>
    </ThemeProvider>
  );
}

export default App;